
import loadFromLocal from "./loadFromLocal";
import saveToLocal from "./saveToLocal";

export default {
    loadFromLocal,
    saveToLocal,
}